import { getBooleanAnswerOptions } from '@app/constants';
import { AnswerType, DependencyType, QuestionDependencyView, QuestionView } from '@data/sdk/match';

export const getBooleanFormInitialValues = (
  dependency: QuestionDependencyView,
  answerType: AnswerType,
) => {
  // Handle hasDisease dependency type
  if (dependency.type === DependencyType.HasDisease) {
    return {
      source: { label: dependency?.text, value: dependency?.sourceId },
      applicableAnswer: dependency.parameters[0] || undefined,
      notApplicableAnswer: dependency.parameters[0]
        ? getBooleanAnswerOptions().find((v) => v.value !== dependency.parameters[0])?.value
        : getBooleanAnswerOptions().find((v) => v.value !== dependency.parameters[1])?.value,
      defaultValue: dependency.parameters[1],
      dependencyType: DependencyType.HasDisease,
      onlyIfUserHasDisease: true,
    };
  }

  // Handle regular dependency (boolean or options source — the stored parameter is the
  // required value either way: a boolean string or an `Option.key`).
  return {
    source: { label: dependency?.text, value: dependency?.sourceId },
    applicableAnswer: dependency?.parameters[0],
    notApplicableAnswer: dependency?.parameters[1],
    defaultValue:
      answerType === AnswerType.Boolean
        ? getBooleanAnswerOptions().find((v) => v.value === dependency?.parameters[1])?.value ?? ''
        : dependency.parameters[1],
    dependencyType: DependencyType.Dependency,
    onlyIfUserHasDisease: false,
  };
};

export const getBooleanFormInitialValuesFromQuestion = (question: QuestionView) => ({
  source: { label: question?.text, value: question?.id },
});
